import React from 'react'
import PaidGiftBody from './PaidGiftBody'
import UnPaidGiftBody from './UnPaidGiftBody'

export default ({
  instruction,
  price,
  score,
  description,
  expirationDate,
  isPaid,
  id,
  icon
}) => {
  const paidProps = {
    link: instruction.link,
    instruction: instruction.text,
    description: description.text,
  }

  const unpaidProps = {
    id,
    price,
    score,
    expirationDate,
    description,
    icon,
  }

  return (
    isPaid ?
      <PaidGiftBody {...paidProps} />
      :
      <UnPaidGiftBody {...unpaidProps} />
  )
}
